<template lang="html">
  <article class="media">
    <div class="media-content">
      <div class="content">
        <p>
          <strong>DevOps</strong> | HG Insights - <small>May 2018 - present</small>
          <br>
At HG I am responsible for using terraform to migrate physical infrastructure to
the cloud and assist development by recognizing pathways to enable productivity
while increasing security, reliability, and repeatability. Utilizing
Infrastructure-as-code requires new thought surrounding source control
flow, including test and CI/CD practices. I enjoy this space as it benefits from
knowledge of traditional software pipelines, while demanding creative thinking
to achieve best practices in a domain with often unexplored constraints and
solutions.
        </p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "hg-insights"
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/jobs/HGInsights.vue